import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import React, { useContext, useState } from 'react';

import { TransactionFilterContext } from '../../context/transaction-filter-context';
import { getTwelveAMOfToday } from '../../helpers/dates';
import './date-range-filter.scss';

const dayNamesShortened = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const monthNamesShortened = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export default function DateRangeFilter(props) {
  const today = getTwelveAMOfToday();
  const weekAgo = new Date(today);
  weekAgo.setDate(weekAgo.getDate() - 7);

  const { transactionFilter, setTransactionFilter } = useContext(TransactionFilterContext);
  const [selectedRangeDates, setSelectedRangeDates] = useState([weekAgo, today]);

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  function rangeUpdated(value) {
    setSelectedRangeDates(value);

    if (value) {
      setTransactionFilter({ ...transactionFilter, selectedDates: value });

      if (props.tealiumEvent) {
        props.tealiumEvent();
      }
    }
  }

  function formatStartDate(date) {
    return `${date.getDate()} ${monthNamesShortened[date.getMonth()]}`;
  }

  function formatEndDate(date) {
    return `${date.getDate()} ${monthNamesShortened[date.getMonth()]} ${date
      .getFullYear()
      .toString()
      .substring(2, 4)}`;
  }

  return (
    <section className="DateRangeFilter" data-testid="date-range-filter">
      <div id="float-label">
        <DateRangePicker
          name="date"
          calendarIcon={<span className="icon is-icon-4 icon-calendar-empty" />}
          value={selectedRangeDates}
          calendarType="US"
          onChange={(value) => {
            rangeUpdated(value);
          }}
          showNeighboringMonth={false}
          next2Label={null}
          prev2Label={null}
          formatShortWeekday={(locale, date) => {
            return dayNamesShortened[date.getDay()];
          }}
          clearIcon={
            isCalendarOpen ? (
              <span
                className="icon is-icon-5 icon-cross-thin"
                onClick={() => {
                  setSelectedRangeDates(null);
                }}
              />
            ) : null
          }
          onCalendarOpen={() => setIsCalendarOpen(true)}
          onCalendarClose={() => setIsCalendarOpen(false)}
        />

        <label className="surtitle">Date</label>
        <label className="title">
          {selectedRangeDates ? (
            `${formatStartDate(selectedRangeDates[0])} - ${formatEndDate(selectedRangeDates[1])}`
          ) : (
            <div>
              From - <span className="lighter-text">To date</span>
            </div>
          )}
        </label>
      </div>
    </section>
  );
}
